import { render, staticRenderFns } from "./LogisticsTotal.vue?vue&type=template&id=150e78d3&scoped=true"
import script from "./LogisticsTotal.vue?vue&type=script&lang=js"
export * from "./LogisticsTotal.vue?vue&type=script&lang=js"
import style0 from "./LogisticsTotal.vue?vue&type=style&index=0&id=150e78d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150e78d3",
  null
  
)

export default component.exports